/**
 * Kanonischer Seiten-Headline-Stil (SSOT) — vereinheitlicht Font, Farbe und
 * Größe über ALLE Seiten-H1s.
 *
 * Redesign S2 (2026-10-10, `tasks/design-handoff-redesign-s2.md` Entscheid 5):
 * The Sans B 28px/700 in normaler Schreibung statt Paradise-Point-Versalien.
 * Paradise Point bleibt den Markenmomenten vorbehalten (Dashboard-Begrüßung,
 * Login, leere Zustände) — die setzen `font-display` selbst, nicht über diese
 * Konstante. Größe kommt aus dem Token `--text-page` (styles.css @theme).
 *
 * Anwendung: `className={PAGE_H1_CLASS}` am `<h1>`. Page-spezifische Extras
 * (Abstände wie `mb-8`, `break-words` für lange dynamische Titel) hinten
 * anhängen: `className={`${PAGE_H1_CLASS} mb-8`}`.
 */
export const PAGE_H1_CLASS = 'text-page font-bold text-ink-900 tracking-[-0.01em]';
